import type { ReactNode } from 'react'
import React from 'react'

export const ChildContent = ({
  leftIcon,
  content,
  rightIcon,
  fullWidth,
  gap = 10,
}: {
  leftIcon: ReactNode
  content: ReactNode
  rightIcon: ReactNode
  fullWidth?: boolean
  gap?: number
}) => {
  return (
    <div
      css={{
        display: 'flex',
        gap,
        alignItems: 'center',
        flex: '1 1 auto',
        justifyContent: fullWidth ? 'space-between' : 'flex-start',
      }}
    >
      {leftIcon ? <div css={{ display: 'flex' }}>{leftIcon}</div> : null}
      <div>{content}</div>
      {rightIcon ? <div css={{ display: 'flex' }}>{rightIcon}</div> : null}
    </div>
  )
}
